'use strict';

frontendApp.factory('BrowserService', [function () {

  var _service = {};

  _service.isSupportedBrowser = function () {

    var userAgent = navigator.userAgent;

    //If it's IE, check version
    if (new RegExp(/(?:\b(MS)?IE\s+|\bTrident\/7\.0;.*\s+rv:)/i).test(userAgent)) {
      var matches = userAgent.match(/(?:\b(MS)?IE\s+|\bTrident\/7\.0;.*\s+rv:)(\d+)/)
      //If less than 10, give a popup
      if (matches.length > 1 && matches[2] < 10) {
        return false;
      }
      return true;
    }

    //White list of browsers
    var browsers = {chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i};

    for (var key in browsers) {
      if (browsers[key].test(userAgent)) {
        return true;
      }
    }


    return false;
  }

  return _service;

}]);
